import React from 'react';
import {concatenate} from "services/string";

enum Size {X_SMALL, SMALL, MEDIUM, LARGE, X_LARGE}

type Props = {
    size: Size,
    src: string,
    alt: string,
}

const sizeClasses: Record<Size, string> = {
    [Size.X_SMALL]: 'h-6 w-6',
    [Size.SMALL]: 'h-8 w-8',
    [Size.MEDIUM]: 'h-10 w-10',
    [Size.LARGE]: 'h-12 w-12',
    [Size.X_LARGE]: 'h-14 w-14',
}

function Avatar(props: Props) {
    const {size, src, alt} = props

    return (
        <img className={concatenate("inline-block rounded-full", sizeClasses[size])} src={src} alt={alt}/>
    );
}

Avatar.sizes = Size

Avatar.defaultProps = {
    size: Size.MEDIUM
}

export default Avatar;